import _ from './safe-area-blur.module.scss'
import React from 'react'

const LAYERS = [1, 2, 3, 4, 5]

export const SafeAreaBlur = () => <div className={_.root} aria-hidden="true">
    {LAYERS.map(layer => <div key={layer} className={_.layer}/>)}
</div>
